import { useLocation, useNavigate } from 'react-router-dom';

import { NavItem } from '@/components/ds';

interface NavigationItemProps {
  path: string;
  label: string;
  icon?: React.ReactNode;
  endIcon?: React.ReactNode;
  disabled?: boolean;
  external?: boolean;
  badge?: number;
  compact?: boolean;
  onClick?: () => void;
}

// A sidebar row wired to the router; the look is the design system's NavItem
export const NavigationItem = ({
  path,
  label,
  icon,
  endIcon,
  disabled = false,
  external = false,
  badge,
  onClick,
}: NavigationItemProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) return;

    if (onClick) {
      onClick();
      return;
    }

    if (external) {
      window.open(path, '_blank');
    } else {
      navigate(path);
    }
  };

  return (
    <NavItem
      label={label}
      icon={icon}
      trailing={endIcon}
      badge={badge}
      disabled={disabled}
      active={location.pathname === path}
      onClick={handleClick}
      testId={`sidebar-nav-${label.toLowerCase().replace(/\s+/g, '-')}`}
    />
  );
};
